import { ConfirmDrawer, useConfirmDrawer } from 'hooks/useConfirmDrawer'
import { ConfirmDeleteDrawer } from 'components/ConfirmDeleteDrawer/ConfirmDeleteDrawer'
import { useConfirmModal } from 'hooks/useConfirmModal'
import { ConfirmDeleteModal } from 'screens/BrandKit/BrandStyles/Modals/ConfirmDeleteModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { FunctionComponent } from 'react'

export const confirmModal = <P extends ConfirmDrawer>(Component: FunctionComponent<P>) => {
  const wrapper = (props: Partial<P>) => <Component {...(props as P)} />
  wrapper.displayName = Component.displayName ?? Component.name
  return wrapper
}

export const useConfirmDelete = () => {
  const { isMobile } = useResponsiveDesign()

  const mobileConfirmDelete = useConfirmDrawer(confirmModal(ConfirmDeleteDrawer))
  const desktopConfirmDelete = useConfirmModal(confirmModal(ConfirmDeleteModal))

  return isMobile ? mobileConfirmDelete : desktopConfirmDelete
}
